<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <div class="item-son">
            <el-input
              v-model="listParams.searchKey"
              placeholder="搜索关键词"
              clearable
              @keyup.enter.native="SearchBusinessDomainList"
            ></el-input>
          </div>
          <div class="item-son">
            <el-select
              v-model="listParams.status"
              clearable
              placeholder="请选择状态"
              style="width: 120px"
            >
              <el-option label="正常" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </div>
<!--          <div class="item-son">-->
<!--            <el-select-->
<!--              v-model="listParams.companyId"-->
<!--              clearable-->
<!--              placeholder="请选择主体"-->
<!--              style="width: 100%"-->
<!--            >-->
<!--              <el-option-->
<!--                v-for="(item, index) in companyData"-->
<!--                :key="index"-->
<!--                :label="item.fullName"-->
<!--                :value="item.companyId"-->
<!--              ></el-option>-->
<!--            </el-select>-->
<!--          </div>-->
          <div class="item-son">
            <el-button type="primary" @click="SearchBusinessDomainList"
              >查询 <i class="el-icon-search"></i>
            </el-button>
          </div>
          <div class="item-son">
            <el-button type="primary" @click="handleClick('add')"
              >新增 <img src="@assets/images/add-icon.png" alt="" />
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="public-table-data">
      <el-table
        ref="multipleTable"
        size="medium"
        :data="tableData"
        border
        style="width: 100%"
        row-key="menuId"
        v-loading="loading"
      >
        <el-table-column
              align="center"
              fixed
              label="序号"
              type="index"
              width="100"
            >
              <template slot-scope="scope">
                <span>{{
                  (pages.pageNo - 1) * pages.pageSize + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>
        <el-table-column
          prop="domainBizAddress"
          label="域名"
          min-width="220"
          align="center"
        >
        </el-table-column>

<!--        <el-table-column prop="name" label="主体" width="200" align="center">-->
<!--        </el-table-column>-->

        <el-table-column prop="descr" label="说明" width="220" align="center">
        </el-table-column>
        <el-table-column prop="ctime" label="时间" width="200" align="center">
        </el-table-column>
        <el-table-column prop="code" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeSwitch(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" fixed="right" min-width="180">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleClick('edit', scope.row)"
              type="warning"
              plain
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="handleDelete(scope.row)"
              type="primary"
              plain
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="public-pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.pageNo"
          :page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
          :page-size="pages.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
      title="增加/编辑业务域名"
      :visible.sync="dialogVisible"
      width="560px"
      :close-on-click-modal="false"
      class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="params"
          label-width="80px"
        >
          <el-form-item label="业务域名" prop="http">
            <el-select
              v-model="params.http"
              clearable
              placeholder="请选择"
              style="width: 120px; margin-right: 10px"
            >
              <el-option label="http://" value="http://"></el-option>
              <el-option label="https://" value="https://"></el-option>
            </el-select>

            <el-input
              placeholder="请填写备案域名"
              v-model="params.prefix"
              :disabled="isDisabled"
              style="width: 150px; margin-right: 10px"
            ></el-input>

            <el-select
              v-model="params.domainId"
              clearable
              filterable
              placeholder="请选择备案域名"
              style="width: 150px"
              :disabled="isDisabled"
              @change="selectDomain"
            >
              <el-option
                v-for="(item, index) in recordsList"
                :key="index"
                :label="item.domain"
                :value="item.domainId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="主体">
            <el-input
              placeholder=""
              v-model="params.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="说明" prop="descr">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入说明"
                v-model="params.descr"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="显示备案" prop="descr">
              <el-switch
                  v-model="params.copyrightStatus"
                  :active-value="1"
                  :inactive-value="0"
              >
              </el-switch>
            <span style="margin-left: 15px">该备案信息在没有渠道参数的情况下返回</span>
          </el-form-item>
          <el-form-item prop="descr">
            <el-input
                placeholder="业务域名备案主体名称"
                v-model="params.copyrightName"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="descr">
            <el-input
                placeholder="业务域名备案号"
                v-model="params.copyrightNumber"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { PAGE_SIZE, FILE_ROOT, JOB_STATUS } from "@config";
export default {
  data() {
    return {
      listParams: {
        bizType:'put'
      },
      companyData: [],
      tableData: [],
      recordsList: [],
      params: {
        bizType:'put'
      },
      total: 0,
      PAGE_SIZE,
      dialogVisible: false,
      // isDisabled: false,
      loading: false,
      isDisabled: false,
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      rules: {
        http: [
          {
            required: true,
            message: "请填写或选择业务域名",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.companyList();
    this.queryTableData();
    this.recordsData();
  },
  
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  methods: {
    SearchBusinessDomainList(){
      this.pages.pageNo = 1
      this.queryTableData()
    },
    /**
     * 业务域名列表
     */
    async queryTableData() {
      this.loading = true;

      const { data: resData } = await this.$get("domain/biz/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.total = resData.page.count;
    },

    /**
     * 主体列表（企业列表）
     */
    async companyList() {
      this.loading = true;

      const { data: resData } = await this.$get("company/list?paging=false",

      );
      this.loading = false;
      if (resData.result != 200) return;
      this.companyData = resData.data;
    },
    /**
     * 备案域名列表
     */
    async recordsData() {
      this.loading = true;
      const { data: resData } = await this.$get("domain/list", {
        params: {
          paging: false,
          status: 1,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.recordsList = resData.data;
    },

    /**
     * 修改业务域名状态
     */
    async changeSwitch(b) {
      const { data: resData } = await this.$put(
        `domain/biz/info/status/${b.domainBizId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message({
        message: resData.message,
        type: "success",
      });
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "edit") {
        //编辑
        this.isDisabled = true;
        const { data: resData } = await this.$get(
          `domain/biz/info/${row.domainBizId}`,
          {
            headers: {
              isLoading: true,
            },
          }
        );
        if (resData.result != 200) return;
        this.params = resData.data;
      }
      if (type == "add") {
        this.params = {};
        this.isDisabled = false;
      }
    },

    /**
     * 编辑/新增
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add") {
            const { data: resData } = await this.$post(
              "domain/biz/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("添加成功!");
            this.params = {};
          } else {
            const { data: resData } = await this.$put(
              "domain/biz/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("修改成功!");
          }
        });
      });
    },

    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const { data: resData } = await this.$delete(
          `domain/biz/info/${row.domainBizId}`,
          {
            headers: {
              isLoading: true,
            },
          }
        );
        if (resData.result != 200) return;
        this.queryTableData();

        this.$message.success("删除成功!");
      });
    },
    selectDomain(value) {
      let obj = {}; //定义对象集合
      obj = this.recordsList.find((project) => {
        return project.domainId === value; //筛选出匹配数据 返回对象
      });
      this.params.name = obj.companyVo.fullName;
    },

    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;

      this.queryTableData();
    },

    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;

      this.queryTableData();
    },
  },
};
</script>
<style lang="scss" scoped="">
</style>